'use strict';

var React = require('react');
var IconBase = require('./dist/IconBase.js');

module.exports = function (props) {
    return React.createElement(IconBase, Object.assign({ viewBox: '0 0 1024 1024' }, props, {
        style: { width: '1em' }
    }), React.createElement(
        'g',
        null,
        React.createElement('path', { d: 'M0 192h1024v64h-1024zM0 320h704v64h-704zM0 448h1024v64h-1024zM0 576h704v64h-704zM0 704h1024v64h-1024zM0 832h704v64h-704z' })
    ));
};